export const leaderboardMockData = [
  {
    actions: 47,
    connected: false,
    directions: {
      down: 2,
      left: 22,
      right: 10,
      up: 11,
    },
    exited: true,
    press: false,
    score: 1000,
    initials: "JAR",
    updatedAt: "2021-10-26T21:24:47.021Z",
  },
  {
    actions: 19,
    connected: false,
    directions: {
      down: 3,
      left: 37,
      right: 15,
      up: 11,
    },
    exited: true,
    press: false,
    score: 900,
    initials: "ZTU",
    updatedAt: "2021-10-26T22:06:27.294Z",
  },
  {
    actions: 18,
    connected: false,
    directions: {
      down: 6,
      left: 38,
      right: 39,
      up: 6,
    },
    exited: true,
    press: false,
    score: 800,
    initials: "SLE",
    updatedAt: "2021-10-26T18:29:57.995Z",
  },
  {
    actions: 22,
    connected: false,
    directions: {
      down: 7,
      left: 31,
      right: 34,
      up: 3,
    },
    exited: true,
    press: false,
    score: 700,
    initials: "VTT",
    updatedAt: "2021-10-26T18:29:57.995Z",
  },
  {
    actions: 22,
    connected: false,
    directions: {
      down: 7,
      left: 31,
      right: 34,
      up: 3,
    },
    exited: true,
    press: false,
    score: 600,
    initials: "ARQ",
    updatedAt: "2021-10-26T18:29:57.995Z",
  },
  {
    actions: 22,
    connected: false,
    directions: {
      down: 7,
      left: 31,
      right: 34,
      up: 3,
    },
    exited: true,
    press: false,
    score: 500,
    initials: "NIL",
    updatedAt: "2021-10-26T18:29:57.995Z",
  },
  {
    actions: 22,
    connected: false,
    directions: {
      down: 7,
      left: 31,
      right: 34,
      up: 3,
    },
    exited: true,
    press: false,
    score: 400,
    initials: "POT",
    updatedAt: "2021-10-26T18:29:57.995Z",
  },
  {
    actions: 22,
    connected: false,
    directions: {
      down: 7,
      left: 31,
      right: 34,
      up: 3,
    },
    exited: true,
    press: false,
    score: 300,
    initials: "CUS",
    updatedAt: "2021-10-26T18:29:57.995Z",
  },
  {
    actions: 22,
    connected: false,
    directions: {
      down: 7,
      left: 31,
      right: 34,
      up: 3,
    },
    exited: true,
    press: false,
    score: 200,
    initials: "ILM",
    updatedAt: "2021-10-26T18:29:57.995Z",
  },
  {
    actions: 22,
    connected: false,
    directions: {
      down: 7,
      left: 31,
      right: 34,
      up: 3,
    },
    exited: true,
    press: false,
    score: 100,
    initials: "XDE",
    updatedAt: "2021-10-26T18:29:57.995Z",
  },
];

const FirebaseHelpers = {
  leaderboardMockData,
}

export default FirebaseHelpers
